import * as yup from 'yup'
import { IntlShape, defineMessages } from 'react-intl'

import { IRouteForm } from './types'
import { GTCompanyV2VerticalInput } from 'gql/types.generated'

const messages = defineMessages({
  required: {
    id: 'route.form.required',
    defaultMessage: 'This field is required'
  },
  requiredCompany: {
    id: 'route.form.company.required',
    defaultMessage: 'The company is required'
  },
  requiredCompanyLine: {
    id: 'route.form.companyLine.required',
    defaultMessage: 'The company line is required'
  },
  requiredStops: {
    id: 'route.form.stops.required',
    defaultMessage: 'At least two stops are required'
  },
  requiredStop: {
    id: 'route.form.stop.required',
    defaultMessage: 'The stop is required'
  },
  encodedShape: {
    id: 'route.form.stop.encodedShape.required',
    defaultMessage: 'Calculating the shape is required'
  },
  maxLength: {
    id: 'route.form.maxLength',
    defaultMessage: 'Enter max {nChar} characters'
  }
})

export const routeFormSchema = (
  intl: IntlShape,
  { isCalculatingShape }: { isCalculatingShape: boolean }
): yup.SchemaOf<IRouteForm> => {
  return yup.object().shape({
    businessClients: (yup.array() as yup.SchemaOf<IRouteForm['businessClients']>).when(['vertical', 'isPrivate'], {
      is: (vertical: string, isPrivate: boolean): boolean =>
        vertical === GTCompanyV2VerticalInput.Team ||
        vertical === GTCompanyV2VerticalInput.Rental ||
        (vertical === GTCompanyV2VerticalInput.City && isPrivate),
      then: yup.array().min(1, intl.formatMessage(messages.required))
    }),
    businessSites: yup.array() as yup.SchemaOf<IRouteForm['businessSites']>,
    vertical: yup.string().required(),
    routeName: yup
      .string()
      .optional()
      .max(100, intl.formatMessage(messages.maxLength, { nChar: 100 })),
    routeId: yup.string().optional(),
    company: yup.object().shape({
      id: yup.string().required(intl.formatMessage(messages.requiredCompany)),
      name: yup.string()
    }),
    companyLine: yup.object().shape({
      id: yup.string().required(intl.formatMessage(messages.requiredCompanyLine)),
      name: yup.string().required()
    }),
    stops: yup
      .array()
      .of(
        yup.object({
          id: yup.string().required(intl.formatMessage(messages.requiredStop)),
          name: yup.string().required()
        })
      )
      .min(2, intl.formatMessage(messages.requiredStops)),
    encodedShape: yup.string().when('isCalculatingShape', {
      is: (): boolean => isCalculatingShape,
      then: yup.string().required(intl.formatMessage(messages.encodedShape))
    }),
    distance: yup.string().optional(),
    mapCenterLocation: yup.object().shape({
      lat: yup.number().required(),
      lng: yup.number().required()
    })
  })
}
